// 环境配置 - 改这一行即可切换全工程的请求域名
//   'local' → http://localhost:8080 (本地起后端调试)
//   'test'  → https://api-test.aihear.io  (海外 dev / test)
//   'prod'  → https://api-prod.aihear.io  (海外正式)
const ENVIRONMENT = 'test';

const API_CONFIG = {
  local: 'http://localhost:8080',
  test:  'https://api-test.aihear.io',
  prod:  'https://api-prod.aihear.io',
};

const PRIVACY_POLICY_PATH = '/privacy_policy.html';

export const API_URL = API_CONFIG[ENVIRONMENT];

// 隐私政策跟随当前环境（test / prod 静态页都有部署）
export const PRIVACY_POLICY_URL = `${API_URL}${PRIVACY_POLICY_PATH}`;

export const isProd = ENVIRONMENT === 'prod';
